<template>
  <v-container fluid fill-height>
    <v-layout justify-center align-center>
      <v-flex xs4>
        <v-card dark color="blue-grey darken-1">
          <v-card-title>Authenticating</v-card-title>
          <v-card-text>
          <v-progress-circular
            indeterminate
            color="orange"
          ></v-progress-circular>
            Checking login against authentication servers
          </v-card-text>
        </v-card>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: ['loadingState']
}
</script>

<style>

</style>
